await themeResource(theme.resources['mc-shopify'], false);
await themeComponent(theme.components['mc-element'], false);
await themeComponent(theme.components['mc-viewer'], false);

class McViewed extends McElement {
  connectedCallback() {
    this.render();
  }

  render = () => {
    const container = this.querySelector('[data-container]'); // should be .swiper-wrapper
    const swiperEl  = this.querySelector('mc-swiper');
    const bpEl      = this.querySelector('mc-swiper-breakpoint');
    const sectionId = this.dataset.section || 'helper-viewed';

    if (!container) {
      console.error('McViewed: No container found');
      return;
    }

    const limitAttr = parseInt(this.dataset.limit || container.dataset.limit || '0', 10);
    const limit = Number.isFinite(limitAttr) && limitAttr > 0 ? limitAttr : null;

    const current = document.querySelector('#current-product')?.dataset.handle;

    // Get viewed, drop falsy, drop current, de-dupe, newest first
    let viewed = McViewer.getViewed()
      .filter(Boolean)
      .filter(h => h !== current);

    viewed = [...new Set(viewed)].reverse();
    if (limit) viewed = viewed.slice(0, limit);

    if (viewed.length === 0) {
      this.dispatchEvent(new CustomEvent('mc:viewed-ready', { bubbles: true, detail: { count: 0 } }));
      this.remove();
      return;
    }

    // Skeletons: count = min( data-skeleton-count || visibleSlides*2, viewed.length )
    const visible = this._calcVisibleSlides(swiperEl, bpEl);
    const defaultSkels = Math.max(1, visible * 2);
    const skelAttr = parseInt(this.dataset.skeletonCount || `${defaultSkels}`, 10);
    this._skeletonCount = Math.min(viewed.length, Number.isFinite(skelAttr) && skelAttr > 0 ? skelAttr : defaultSkels);
    this._skeletonNodes = [];
    this._skeletonTemplate = this._buildSkeletonSlide();

    this.setAttribute('aria-busy', 'true');
    this._renderSkeletons(container);

    const fetchSection = (handle) =>
      new Promise((resolve, reject) => {
        McShopify.section({
          path: `${Shopify.routes.root}products/${handle}`,
          section_id: sectionId,
          onSuccess: resolve,
          onError: reject
        });
      });

    Promise.allSettled(viewed.map(fetchSection))
      .then(results => {
        const htmls = results
          .filter(r => r.status === 'fulfilled')
          .map(r => r.value);

        // Swap content in one go
        container.innerHTML = htmls.join('');

        const count = container.children.length;

        if (count > 0) {
          this.hidden = false;
          this.setAttribute('data-ready', '1');
          this.querySelector('mc-swiper')?.swiper?.update?.();
        } else {
          // nothing valid came back
          this.remove();
        }

        this.dispatchEvent(new CustomEvent('mc:viewed-ready', { bubbles: true, detail: { count } }));
      })
      .catch(err => {
        console.error('McViewed: Error fetching sections', err);
        this.dispatchEvent(new CustomEvent('mc:viewed-ready', { bubbles: true, detail: { count: 0 } }));
        this.remove();
      })
      .finally(() => {
        this._removeSkeletons();
        this.removeAttribute('aria-busy');
      });
  };

  _calcVisibleSlides(swiperEl, bpEl) {
    const m  = parseFloat(swiperEl?.dataset?.slides || '1') || 1;
    const bp = parseInt(bpEl?.dataset?.breakpoint || '0', 10) || 0;
    const d  = parseFloat(bpEl?.dataset?.slides || `${m}`) || m;
    const desktop = bp > 0 && window.innerWidth >= bp;
    return desktop ? d : m;
  }

  _buildSkeletonSlide() {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide mc-skel';
    slide.setAttribute('data-skel', '1');
    // mirror real card proportions to avoid CLS
    slide.innerHTML = `
      <div class="product-card">
        <div class="card-image">
          <span class="lazy__uncollapser"></span>
        </div>
        <div style="height: 102px"></div>
      </div>
    `;
    return slide;
  }

  _renderSkeletons(container) {
    const frag = document.createDocumentFragment();
    this._skeletonNodes = [];
    for (let i = 0; i < this._skeletonCount; i++) {
      const node = this._skeletonTemplate.cloneNode(true);
      this._skeletonNodes.push(node);
      frag.appendChild(node);
    }
    container.appendChild(frag);
  }

  _removeSkeletons() {
    if (this._skeletonNodes?.length) {
      this._skeletonNodes.forEach(n => n?.remove());
      this._skeletonNodes = [];
    }
  }
}

if (!window.customElements.get('mc-viewed')) {
  window.customElements.define('mc-viewed', McViewed);
}
window.McViewed = McViewed;
